/**
 * DUO Code Action Handler
 */

export function initDueCode() {
	// Listen for popup open to load code
	document.addEventListener('popup-opened', function(e) {
		if (e.detail && e.detail.target === 'due-code') {
			loadUserCode();
		}
	});

	// Handle copy button click
	document.addEventListener('click', async (e) => {
		const copyBtn = e.target.closest('[data-action="copy-due-code"]');
		if (!copyBtn) return;

		e.preventDefault();

		const codeDisplay = document.getElementById('user-due-code-display');
		if (!codeDisplay) return;

		const code = codeDisplay.textContent.trim();
		if (!code || code === '---') return;

		try {
			await navigator.clipboard.writeText(code);

			// Show success feedback
			const originalHTML = copyBtn.innerHTML;
			copyBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 16 16" fill="none"><path d="M13.3333 4L6 11.3333L2.66667 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
			copyBtn.disabled = true;

			setTimeout(() => {
				copyBtn.innerHTML = originalHTML;
				copyBtn.disabled = false;
			}, 1500);
		} catch (err) {
			console.error('[DUO Code] Copy failed:', err);
		}
	});

	// Handle form submit
	document.addEventListener('submit', async (e) => {
		if (e.target.id !== 'due-code-form') return;

		e.preventDefault();

		const emailInput = document.getElementById('due-code-emails');
		const submitBtn = document.getElementById('send-due-code-btn');

		if (!emailInput || !submitBtn) return;

		// Validate emails
		const validation = validateEmails(emailInput.value);
		if (!validation.valid) return;

		// Disable button
		const originalText = submitBtn.textContent;
		submitBtn.disabled = true;
		submitBtn.textContent = wpcore.direct_t({ en: 'Sending...', fr: 'Envoi...' });

		try {
			const formData = new FormData();
			formData.append('action', 'wpcore_send_due_code');
			formData.append('nonce', wpcore_due_code.nonce);
			formData.append('emails', JSON.stringify(validation.emails));

			const response = await fetch(wpcore_due_code.ajax_url, {
				method: 'POST',
				body: formData
			});

			const data = await response.json();

			// Close popup
			if (typeof wpcore !== 'undefined' && wpcore.closePopup) {
				wpcore.closePopup('due-code');
			}

			// Show alert
			setTimeout(() => {
				if (window.wpcore && window.wpcore.showAlert) {
					if (data.success) {
						// Update code display if new code created
						if (data.data.code) {
							const codeDisplay = document.getElementById('user-due-code-display');
							if (codeDisplay) {
								codeDisplay.textContent = data.data.code;
							}
						}

						// Clear input
						emailInput.value = '';

						window.wpcore.showAlert('success', wpcore.direct_t({ en: 'Success!', fr: 'Succ\u00e8s !' }), data.data.message);
					} else {
						window.wpcore.showAlert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), data.data.message || wpcore.direct_t({ en: 'An error occurred.', fr: 'Une erreur est survenue.' }));
					}
				}
			}, 300);
		} catch (error) {
			console.error('[DUO Code] Error:', error);

			if (typeof wpcore !== 'undefined' && wpcore.closePopup) {
				wpcore.closePopup('due-code');
			}

			setTimeout(() => {
				if (window.wpcore && window.wpcore.showAlert) {
					window.wpcore.showAlert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), wpcore.direct_t({ en: 'Connection error. Please try again.', fr: 'Erreur de connexion. Veuillez r\u00e9essayer.' }));
				}
			}, 300);
		} finally {
			submitBtn.disabled = false;
			submitBtn.textContent = originalText;
		}
	});

	// Handle email input for realtime validation
	document.addEventListener('input', (e) => {
		if (e.target.id !== 'due-code-emails') return;

		const emailInput = e.target;
		const submitBtn = document.getElementById('send-due-code-btn');
		const errorDisplay = document.getElementById('due-code-error');

		if (!submitBtn || !errorDisplay) return;

		const validation = validateEmails(emailInput.value);

		if (!validation.valid) {
			errorDisplay.textContent = validation.message;
			errorDisplay.classList.remove('hidden');
			submitBtn.disabled = true;
		} else {
			errorDisplay.classList.add('hidden');
			submitBtn.disabled = false;
		}
	});
}

/**
 * Validate email list
 */
function validateEmails(emailText) {
	if (!emailText || !emailText.trim()) {
		return { valid: false, message: wpcore.direct_t({ en: 'Please enter at least one email.', fr: 'Veuillez entrer au moins une adresse e-mail.' }) };
	}

	const emails = emailText.split(/[\s,;]+/).filter(e => e.length > 0);

	if (emails.length === 0) {
		return { valid: false, message: wpcore.direct_t({ en: 'Please enter at least one email.', fr: 'Veuillez entrer au moins une adresse e-mail.' }) };
	}

	if (emails.length > 10) {
		return { valid: false, message: wpcore.direct_t({ en: 'Maximum 10 emails per send.', fr: 'Maximum 10 e-mails par envoi.' }) };
	}

	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	const invalidEmails = emails.filter(email => !emailRegex.test(email));

	if (invalidEmails.length > 0) {
		return { valid: false, message: wpcore.direct_t({ en: 'Invalid email format.', fr: 'Format d\'e-mail invalide.' }) };
	}

	return { valid: true, emails: emails };
}

/**
 * Load user's DUO Code via AJAX
 */
async function loadUserCode() {
	if (typeof wpcore_due_code === 'undefined' || !wpcore_due_code.user_logged_in) {
		console.warn('[DUO Code] wpcore_due_code not defined or user not logged in');
		return;
	}

	try {
		const formData = new FormData();
		formData.append('action', 'wpcore_get_user_due_code');
		formData.append('nonce', wpcore_due_code.nonce);

		const response = await fetch(wpcore_due_code.ajax_url, {
			method: 'POST',
			body: formData
		});

		const data = await response.json();

		if (data.success && data.data.code) {
			const codeDisplay = document.getElementById('user-due-code-display');
			if (codeDisplay) {
				codeDisplay.textContent = data.data.code;
			}
		}
	} catch (error) {
		console.error('[DUO Code] Error loading code:', error);
	}
}
